module.exports = __webpack_public_path__ + "static/img/Round-16-2018.90a0b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-16-2018.jpg
// module id = Txnm
// module chunks = 0